var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.79 14c.267-1.32.267-2.68 0-4h2.94a7.815 7.815 0 010 4h-2.94zm-2.15 5.54A21.871 21.871 0 0016.25 16h2.66a7.94 7.94 0 01-4.27 3.54zm-2.65.46a23.312 23.312 0 01-2.13-4h4.26a23.242 23.242 0 01-2.13 4zm-6.92-4h2.66a21.79 21.79 0 001.61 3.54A7.942 7.942 0 015.07 16zm-.82-6h2.94a10.088 10.088 0 000 4H4.25a7.815 7.815 0 010-4zm5.09-5.54A21.752 21.752 0 007.73 8H5.07a7.942 7.942 0 014.27-3.54zM11.99 4a23.242 23.242 0 012.13 4H9.86a23.312 23.312 0 012.13-4zm3 8a9.23 9.23 0 01-.24 2H9.23a9.23 9.23 0 01-.24-2 9.23 9.23 0 01.24-2h5.52a9.23 9.23 0 01.24 2zm3.92-4h-2.66a21.832 21.832 0 00-1.61-3.54A7.94 7.94 0 0118.91 8zm-5.75-5.93a9.848 9.848 0 00-2.34 0 10 10 0 000 19.86 9.69 9.69 0 002.32 0 10 10 0 000-19.86h.02z",
    fill: "#38e5e2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.115a00f6c58d6ba975ab80e98b2616cd.svg";
export { ForwardRef as ReactComponent };